import { TableHead, TableRow, TableBody } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Case } from '../../../../shared/api/hscan/case';
import { PresentationalTableProps } from '../../common/components/SortableTable/PresentationalTable';
import {
  HscanTable,
  HscanTableCell,
} from '../../common/components/SortableTable/Table';
import { useModalityLabel } from '../../hooks/modalityHook';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';
import {
  TableContext,
  TableInformationProvider,
} from '../ImageList/ImageListTable';

import { MobileSelectedImageTable } from './MobileSelectedImageTable';

// 아래 전체 컴포넌트랑 구분하기 위해 Normal prefix 사용
const NormalSelectedImageTable = () => {
  const { data } = useContext(TableContext);
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.sendImages.imageTable',
  });
  const modalityLabel = useModalityLabel();

  return (
    <HscanTable
      head={
        <TableHead>
          <TableRow>
            <HscanTableCell>{`${t('header.number')}`}</HscanTableCell>
            <HscanTableCell>{`${t('header.institutionName')}`}</HscanTableCell>
            <HscanTableCell>{`${t('header.patientName')}`}</HscanTableCell>
            <HscanTableCell>{`${t('header.patientSex')}`}</HscanTableCell>
            <HscanTableCell>{`${t('header.studyDate')}`}</HscanTableCell>
            <HscanTableCell>{`${t('header.modality')}`}</HscanTableCell>
            <HscanTableCell>{`${t('header.bodyPart')}`}</HscanTableCell>
          </TableRow>
        </TableHead>
      }
      body={
        <TableBody>
          {data.map((caseInfo, index) => (
            <TableRow key={caseInfo.caseId}>
              <HscanTableCell>{index + 1}</HscanTableCell>
              <HscanTableCell>{caseInfo.institutionName ?? ''}</HscanTableCell>
              <HscanTableCell>{caseInfo.patientName}</HscanTableCell>
              <HscanTableCell>{caseInfo.patientSex}</HscanTableCell>
              <HscanTableCell>{caseInfo.studyDate}</HscanTableCell>
              <HscanTableCell>
                {modalityLabel(caseInfo.modality)}
              </HscanTableCell>
              <HscanTableCell>
                {caseInfo.bodyPart?.join(', ') ?? ''}
              </HscanTableCell>
            </TableRow>
          ))}
          {!data.length && (
            <TableRow>
              <HscanTableCell align="center" colSpan={7}>
                {`${t('row.noEntry')}`}
              </HscanTableCell>
            </TableRow>
          )}
        </TableBody>
      }
    />
  );
};

export const SelectedImageTable = (
  props: Omit<PresentationalTableProps<Case, 'caseId'>, 'identifyKey'>,
) => {
  const windowSize = useContext(WindowSizeContext);

  return (
    <TableInformationProvider {...props} identifyKey="caseId">
      {windowSize === WindowSize.MOBILE ? (
        <MobileSelectedImageTable />
      ) : (
        <NormalSelectedImageTable />
      )}
    </TableInformationProvider>
  );
};
